<!-- <template>
	<div id="app">
		<Layout class="app-frame" :siderCollapsed="sliderCollapsed" :siderFixed="layoutConfig.siderFixed">
			<Sider :theme="layoutConfig.siderTheme">
				<appMenu :theme="layoutConfig.siderTheme"></appMenu>
			</Sider>
			<Layout :headerFixed="layoutConfig.headerFixed">
				<HHeader theme="white">
					<appHead @openSetting="openSetting=true" :layoutConfig="layoutConfig"></appHead>
				</HHeader>
				<SysTabs v-if="layoutConfig.showSystab" homePage="Home"></SysTabs>
				<Content class="flex flex-column">
					<div v-if="!LOGINSTATUS" class="bg-white-color">
						<Tabs class-name="h-tabs-card px-8px mt-8px" :datas="tabs" v-model="selectedTab" @clickItem="tabClick">
							<template #item="{tab}">
								<span>{{ tab.title }}</span>
								<i @click.stop="closeTab(tab.key)" class="h-icon-close-min" v-if="tab.key!=='Home'"></i>
							</template>
						</Tabs>
					</div>
					<div class="app-frame-content flex1" style="height: 0;overflow-y: auto">
						<template v-for="tab in tabs" :key="tab.key">
							<component v-show="currentTab === tab.key" is="ReportView" :is="tab.params.dimension" :dimension="tab.params.dimension" :reportId="tab.params.reportId" v-if="tab.key.startsWith('ReportView')"/>
							<component v-show="currentTab === tab.key" :is="tab.key" v-else/>
						</template>
					</div>
				</Content>
			</Layout>
		</Layout>
	</div>
</template>
<script>

	import appHead from './app/app-header';
	import appMenu from './app/app-menu';
	import appFooter from './app/app-footer';
	import {mapGetters, mapMutations, mapState} from 'vuex';
	import SysTabs from './app/sys-tabs/sys-tabs';

	export default {
		name: "FXY",
		data() {
			return {
				openSetting: false,
				selectedTab: "Home",
				isRouterAlive: true,
				layoutConfig: {
					siderTheme: 'dark',
					showSystab: false,
					headerFixed: true,
					siderFixed: true
				},
				LOGINSTATUS: null
			};
		},
		watch: {
			currentTab(val) {
				this.selectedTab = val;
				localStorage.setItem("currentTab", JSON.stringify(this.tabMap[val]));
				location.hash = val;
			}
		},
		methods: {
			...mapMutations(['changeTab', 'newTab']),
			updateLayoutConfig({key, value}) {
				this.layoutConfig[key] = value;
			},
			closeTab(key) {
				if (key === 'CloseAllTab') {
					// tableData为原数组，row.id为将要删除的对象的id
					// 使用过滤器筛选出id不等于要删除的数据的所有对象，并将其重新赋值给list数组
					this.tableData = this.tabs.filter((item) => {
						return item.key !== 'Home' && item.key !== 'CloseAllTab';
					});
					this.tableData.forEach(item => {
						this.$store.commit('closeTab', item.key);
					})
					this.$store.commit('refreshHomeTab', {key: "Home", title: "首页"})
					this.$store.commit('changeTab', 'Home');
				} else {
					this.$store.commit('closeTab', key);
					if (this.currentTab === 'CloseAllTab') {
						this.$store.commit('refreshHomeTab', {key: "Home", title: "首页"})
						this.$store.commit('changeTab', 'Home');
					}
				}
			},
			tabClick({key}) {
				if (key !== 'CloseAllTab') {
					if (this.currentTab !== key) {
						if (key === 'Home') {
							this.$store.commit('refreshHomeTab', {key: "Home", title: "首页"})
						}
						this.$store.commit('changeTab', key);
					}
				}
			}
		},
		computed: {
			...mapState(['sliderCollapsed', 'tabs', 'currentTab', 'menus']),
			...mapGetters(['tabMap'])
		},
		components: {
			appHead,
			appMenu,
			appFooter,
			SysTabs
		},
		created() {
			this.LOGINSTATUS = localStorage.getItem("LOGINSTATUS")
			const currentTab = localStorage.getItem("currentTab")
			if (currentTab) {
				this.newTab(JSON.parse(currentTab));
			}
		}
	};
</script>
<style scoped lang="less">
	.h-icon-close-min {
		margin-left: 10px;
		font-weight: bold;

		&:hover {
			color: #f60 !important;
		}
	}
</style> -->
<template>
	<div id="app">
		<!-- 添加 Coze Chat 组件 -->
		<CozeChat ref="cozeChat"/>
		<Layout class="app-frame" :siderCollapsed="sliderCollapsed" :siderFixed="layoutConfig.siderFixed">
			<Sider :theme="layoutConfig.siderTheme">
				<appMenu :theme="layoutConfig.siderTheme"></appMenu>
			</Sider>
			<Layout :headerFixed="layoutConfig.headerFixed">
				<HHeader theme="white">
					<appHead @openSetting="openSetting=true" :layoutConfig="layoutConfig"></appHead>
				</HHeader>
				<SysTabs v-if="layoutConfig.showSystab" homePage="Home"></SysTabs>
				<Content class="flex flex-column">
					<div v-if="!LOGINSTATUS" class="bg-white-color">
						<Tabs class-name="h-tabs-card px-8px mt-8px" :datas="tabs" v-model="selectedTab" @clickItem="tabClick">
							<template #item="{tab}">
								<span
									@contextmenu="onTabRightClick($event, tab)"
									class="tab-context-menu-item"
								>
									{{ tab.title }}
								</span>
								<i @click.stop="closeTab(tab.key)" class="h-icon-close-min" v-if="tab.key !== 'Home'"></i>
							</template>
						</Tabs>

						<!-- 右键菜单 -->
						<div
							v-show="showContextMenu"
							class="context-menu"
							:style="{ top: menuTop + 'px', left: menuLeft + 'px' }"
							@click.stop
						>
							<ul style="display: flex;flex-direction: column;">
								<li style="padding:10px" class="h-icon-close" @click="handleCloseCurrent"> 关闭当前</li>
								<li style="padding:10px" class="h-icon-minus" @click="handleCloseOthers"> 关闭其他</li>
								<li style="padding:10px" class="h-icon-refresh" @click="handleCloseAll"> 关闭全部</li>
								<li style="padding:10px" class="h-icon-left" @click="handleCloseLeft"> 关闭左侧</li>
								<li style="padding:10px" class="h-icon-right" @click="handleCloseRight"> 关闭右侧</li>
							</ul>
						</div>
					</div>

					<div class="app-frame-content flex1" style="height: 0; overflow-y: auto">
						<template v-for="tab in tabs" :key="tab.key">
							<component
								v-show="currentTab === tab.key"
								is="ReportView"
								:is="tab.params.dimension"
								:dimension="tab.params.dimension"
								:reportId="tab.params.reportId"
								v-if="tab.key.startsWith('ReportView')"
							/>
							<component
								v-show="currentTab === tab.key"
								:is="tab.key"
								v-else
							/>
						</template>
					</div>
				</Content>
			</Layout>
		</Layout>
	</div>
</template>

<script>
import appHead from './app/app-header';
import appMenu from './app/app-menu';
import appFooter from './app/app-footer';
import { mapGetters, mapMutations, mapState } from 'vuex';
import SysTabs from './app/sys-tabs/sys-tabs';
import CozeChat from '@/components/CozeChat'; // 使用 @ 别名确保路径正确

export default {
	name: 'FXY',
	data() {
		return {
			openSetting: false,
			selectedTab: 'Home',
			isRouterAlive: true,
			layoutConfig: {
				siderTheme: 'dark',
				showSystab: false,
				headerFixed: true,
				siderFixed: true
			},
			LOGINSTATUS: null,

			// 右键菜单相关
			showContextMenu: false,
			menuTop: 0,
			menuLeft: 0,
			currentRightClickedTab: null
		};
	},
	watch: {
		currentTab(val) {
			this.selectedTab = val;
			localStorage.setItem('currentTab', JSON.stringify(this.tabMap[val]));
			location.hash = val;
		}
	},
	methods: {
		...mapMutations(['changeTab', 'newTab', 'closeTab', 'refreshHomeTab']),

		updateLayoutConfig({ key, value }) {
			this.layoutConfig[key] = value;
		},

		// 打开AI聊天窗口（供头部按钮调用）
		openAIChat() {
			if (this.$refs.cozeChat) {
				this.$refs.cozeChat.toggleChatWindow();
			}
		},

		// 原 closeTab 方法已通过 mapMutations 引入，这里重写逻辑（关键修复）
		closeTab(key) {
			if (key === 'CloseAllTab') {
				// 过滤出非 Home 和非 CloseAllTab 的 tab
				const tabsToClose = this.tabs.filter(item => item.key !== 'Home' && item.key !== 'CloseAllTab');
				tabsToClose.forEach(tab => {
					this.$store.commit('closeTab', tab.key);
				});
				this.$store.commit('refreshHomeTab', { key: 'Home', title: '首页' });
				this.$store.commit('changeTab', 'Home');
			} else {
				this.$store.commit('closeTab', key);
				if (this.currentTab === key) {
					// 如果关闭的是当前 tab，切换到 Home
					this.$store.commit('changeTab', 'Home');
				}
			}
		},

		tabClick({ key }) {
			if (key !== 'CloseAllTab') {
				if (this.currentTab !== key) {
					if (key === 'Home') {
						this.$store.commit('refreshHomeTab', { key: 'Home', title: '首页' });
					}
					this.$store.commit('changeTab', key);
				}
			}
		},

		// 右键点击处理
		onTabRightClick(event, tab) {
			event.preventDefault(); // 阻止默认右键菜单
			this.currentRightClickedTab = tab;
			this.menuLeft = event.clientX;
			this.menuTop = event.clientY;
			this.showContextMenu = true;

			// 点击外部关闭菜单
			this.bindOutsideClick();
		},

		bindOutsideClick() {
			const handler = () => {
				this.showContextMenu = false;
				document.removeEventListener('click', handler);
			};
			this.$nextTick(() => {
				document.addEventListener('click', handler);
			});
		},

		// 右键菜单操作
		handleCloseCurrent() {
			if (this.currentRightClickedTab.key !== 'Home') {
				this.closeTab(this.currentRightClickedTab.key);
			}
			this.showContextMenu = false;
		},

		

		// 关闭全部（只保留 Home）
		handleCloseAll() {
			const keysToClose = this.tabs
				.filter(tab => tab.key !== 'Home')
				.map(tab => tab.key);

			keysToClose.forEach(key => {
				this.$store.commit('closeTab', key);
			});

			this.$store.commit('changeTab', 'Home');
			this.showContextMenu = false;
		},


		handleCloseLeft() {
			const currentIndex = this.tabs.findIndex(t => t.key === this.currentRightClickedTab.key);
			if (currentIndex <= 0) {
				this.showContextMenu = false;
				return;
			}
			const keysToClose = this.tabs
				.filter((tab, index) => index < currentIndex && tab.key !== 'Home')
				.map(tab => tab.key);
			keysToClose.forEach(key => this.$store.commit('closeTab', key));
			this.showContextMenu = false;
		},

		handleCloseRight() {
			const currentIndex = this.tabs.findIndex(t => t.key === this.currentRightClickedTab.key);
			if (currentIndex === -1) {
				this.showContextMenu = false;
				return;
			}
			const keysToClose = this.tabs
				.filter((tab, index) => index > currentIndex)
				.map(tab => tab.key);
			keysToClose.forEach(key => this.$store.commit('closeTab', key));
			this.showContextMenu = false;
		},

		handleCloseOthers() {
			const keepKeys = ['Home', this.currentRightClickedTab.key];
			const keysToClose = this.tabs
				.filter(tab => !keepKeys.includes(tab.key))
				.map(tab => tab.key);
			keysToClose.forEach(key => this.$store.commit('closeTab', key));
			this.showContextMenu = false;
		}

		
	},
	// 新增：全局错误捕获，专门针对 CozeChat 组件的异常处理
	errorCaptured(err, vm, info) {
		// 检查出错组件的名称是否包含 CozeChat
		const componentName = vm ? (vm.$options.name || '') : '';
		if (componentName === 'CozeChat') {
		console.warn('检测到 CozeChat 组件异常，已自动隔离，不影响主页面:', err);
		// 返回 false 阻止错误向上传播导致整个 App 崩溃
		return false;
		}
		// 其他错误正常抛出
		return true;
 	},
	computed: {
		...mapState(['sliderCollapsed', 'tabs', 'currentTab', 'menus']),
		...mapGetters(['tabMap'])
	},
	components: {
		appHead,
		appMenu,
		appFooter,
		SysTabs,
		CozeChat  // 新增组件
	},
	mounted() {
		// 把App实例挂载到全局，让头部可以调用
		window.$app = this;
	},
	created() {
		this.LOGINSTATUS = localStorage.getItem('LOGINSTATUS');
		const currentTab = localStorage.getItem('currentTab');
		if (currentTab) {
			this.newTab(JSON.parse(currentTab));
		}
	},
	// 页面卸载时清理事件
	beforeDestroy() {
		document.removeEventListener('click', () => {
			this.showContextMenu = false;
		});
	}
};
</script>

<style scoped lang="less">
.h-icon-close-min {
	margin-left: 10px;
	font-weight: bold;

	&:hover {
		color: #f60 !important;
	}
}

.tab-context-menu-item {
	padding: 0 8px;
	cursor: pointer;
	user-select: none;
	display: inline-block;
	position: relative;
}

.context-menu {
	position: fixed;
	background: #fff;
	border: 1px solid #ddd;
	border-radius: 4px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	z-index: 1000;
}

.context-menu ul {
	list-style: none;
	margin: 0;
	padding: 4px 0;
}

.context-menu li {
	padding: 6px 16px;
	cursor: pointer;
	font-size: 14px;
	color: #333;
}

.context-menu li:hover {
	background-color: #f5f5f5;
}
</style>
